export const CountCard = ({label, value, icon, orange, currency}) => {
  return (
    <div className="w-full col-span-3 lg:col-span-1 flex justify-between gap-2 items-center bg-white !rounded-xl p-6 ">
      <div className="flex flex-col justify-center items-start gap-1">
        <span className="text-[#7E7E7E] text-[13px] leading-5 font-medium">
          {label}
        </span>
        <span
          className={`text-2xl font-bold ${
            !!orange ? "text-[#FF6600]" : "text-[#1A64B9]"
          }`}
        >
          {value + " " + (!!currency ? currency : "")}
        </span>
      </div>

      <div
        className={`h-full aspect-square flex justify-center items-center text-xl !rounded-md ${
          !!orange ? "bg-[#FF6600] text-white" : "bg-[#F1F2F7] text-[#1A64B9]"
        }`}
      >
        {icon}
      </div>
    </div>
  );
};

export default CountCard;
